/**
 * Private modules
 */
const {
  createQueryComponent,
  drawId,
  locale,
  objectId,
  rootId,
  type,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

/**
 * Constant variables
 */
const number = { type: ['null', 'string'] };
module.exports = {
  getDrawSystemGameTypeResultsByRootId: {
    properties: {
      params: {
        properties: {
          drawId,
          rootId,
        },
        required: [
          'drawId',
          'rootId',
        ],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  printDrawSystemGameTypeResultsByRootId: {
    properties: {
      body: {
        properties: {
          locale,
          type,
        },
        required: [
          'locale',
          'type',
        ],
        type: 'object',
      },
      params: {
        properties: {
          drawId,
          rootId,
        },
        required: [
          'drawId',
          'rootId',
        ],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  shareDrawSystemGameTypeResultsByRootId: {
    properties: {
      body: {
        properties: {
          locale,
          type,
        },
        required: [
          'locale',
          'type',
        ],
        type: 'object',
      },
      params: {
        properties: {
          drawId,
          rootId,
        },
        required: [
          'drawId',
          'rootId',
        ],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  updateDrawSystemGameTypeResultsByRootId: {
    properties: {
      body: {
        properties: {
          elements: {
            items: {
              properties: {
                number,
                objectId,
              },
              required: [
                'number',
                'objectId',
              ],
              type: 'object',
            },
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
        },
        required: ['elements'],
        type: 'object',
      },
      params: {
        properties: {
          drawId,
          rootId,
        },
        required: [
          'drawId',
          'rootId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
